<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">
    Attachment Details
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  <div class="divShadow1">
    
    <!-- Loading Indicator -->
    @if (loadingData) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    <!-- Content when loaded -->
    @if (!loadingData) {
<div>
      
      <!-- First Table - Schedule Info -->
      <div class="table-container">
        <table class="schedule-table">
          <thead>
            <tr>
              <th style="width: 20%;">Schedule</th>
              <th style="width: 20%;">Line No.</th>
              <th style="width: 20%;">Column No.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ generalInfo.schdName }}</td>
              <td>{{ generalInfo.lineNumber }}</td>
              <td>{{ generalInfo.colNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br/>

      <!-- Second Table - Results -->
      <div class="table-container results-table-container">
        <table class="results-table">
          <thead>
            <tr>
              <th style="width: 30%;">Gross Inc/Exp</th>
              <th style="width: 30%;">Expense Category</th>
              <th style="width: 20%; text-align: center;">Amount</th>
            </tr>
          </thead>
          <tbody>
            @if (resultJson && resultJson.length > 0) {

              @for (item of resultJson; track $index) {
<tr>
                <td>{{ item.GIE_DESC }}</td>
                <td>{{ item.ALT_GIE_DESC }}</td>
                <td class="amount-cell" [ngClass]="{'negative-no': isNegativeAmount(item)}">
                  {{ item.AMOUNT_FORMATTED }}
                </td>
              </tr>
}
            
}
          </tbody>
        </table>
      </div>

    </div>
}
  </div>
</div>
